module.exports = __webpack_public_path__ + "5ffc3938996788a731e5d05e694f5ff5.jpg";